/*eslint-disable*/
import React, { useState } from "react";
import { useTable } from "react-table";
import classnames from "classnames";
// A great library for fuzzy filtering/sorting items
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { IconButton } from '@material-ui/core';
import { Clear as ClearIcon } from '@material-ui/icons';
// core components
import CustomInput from "components/CustomInput/CustomInput.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { Redirect } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";
import styles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";

const useStyles = makeStyles((theme) => ({
  ...styles,
  formControlMargins: {
    margin: "3px 0 !important",
  },
  gridContainer: {
    justifyContent: "center",
  },
  formControlMargins2: {
    margin: "24px 0 0 0 !important",
  },
dateContainer:{
  display: "flex", alignItems: "center"
},
  dateInput: {
    width: "100%",
    // marginTop: 5,
    border: "none",
    borderBottom: "2px solid transparent", // Default border
    outline: "none",
    fontSize: "1rem",
    padding: 0,
    height: 25,
    transition: "border-color 0.3s",
    "&:focus": {
      borderBottom: `2px solid ${theme.palette.primary.main}`, // Blue border on hover or focus
    },
  },
  dateInputMargin: {
   marginTop:10,
  },
}));
// Our table component
function ReactTable({
  columns,
  data,
  currentPage,
  setCurrentPage,
  pageSize,
  setPageSize,
  totalPages,
  isLoading,
  setFilterValues,
  filterValues,
  sortColumn,
  setSortColumn,
  sortOrder,
  setOrder,
}) {
  const classes = useStyles();

  const open_link = (url) => {
    console.log(url.original.url);
    setRedirctTo(url.original.url);
  };

  const [redirctTo, setRedirctTo] = useState(false);

  const defaultColumn = React.useMemo(
    () => ({
      // Let's set up our default Filter UI
      // Filter: DefaultColumnFilter,
    }),
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } =
    useTable({
      columns,
      data,
      defaultColumn, // Be sure to pass the defaultColumn option
    });
  let numberOfRowsData = [5, 10, 20, 25, 50, 100];

  if (redirctTo) {
    return <Redirect to={redirctTo} />;
  }

  const TextSearchInput = (id) => {
    return (
      <CustomInput
        formControlProps={{
          fullWidth: true,
        }}
        inputProps={{
          value: filterValues[id] || "",
          onChange: (e) => {
            const value = e.target.value;
            const newFilterValues = { ...filterValues, [id]: value };
            setFilterValues(newFilterValues);
          },
          placeholder: `Search`,
        }}
      />
    );
  };
  const SelectInput = (id, options = []) => {
    return (
      <FormControl
        fullWidth
        className={
          classes.selectFormControl + " " + classes.formControlMargins2
        }
      >
        <Select
          MenuProps={{
            className: classes.selectMenu,
          }}
          classes={{
            select: classes.select,
          }}
          value={filterValues[id] || ""}
          onChange={(e) => {
            const value = e.target.value;
            const newFilterValues = { ...filterValues, [id]: value };
            setFilterValues(newFilterValues);
          }}
          inputProps={{
            name: id,
            id: id,
          }}
        >
          {options.map((item) => (
            <MenuItem
              key={item.value}
              classes={{
                root: classes.selectMenuItem,
                selected: classes.selectMenuItemSelected,
              }}
              value={item.value}
            >
              {item.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };
  const DateInput = (id) => {
    return (
      <FormControl
        fullWidth
        className={
          classes.selectFormControl + " " + classes.formControlMargins2
        }
      >
        <div className={classes.dateContainer}>
          <input
            type="date"
            name={id}
            className={`${classes.dateInput} ${!filterValues[id] && classes.dateInputMargin}`}
            value={filterValues[id] || ""}
            onChange={(e) => {
              const value = e.target.value;
              const newFilterValues = { ...filterValues, [id]: value };
              setFilterValues(newFilterValues);
            }}
          />
          {filterValues[id] && (
            <IconButton
              onClick={() => {
                const newFilterValues = { ...filterValues, [id]: "" };
                setFilterValues(newFilterValues);
              }}
            >
              <ClearIcon />
            </IconButton>
          )}
        </div>
      </FormControl>
    );
  };

  return (
    <>
      <div
        className="ReactTable -striped -highlight"
        style={{ minWidth: "1000px", overflow: "auto" }}
      >
        <div className="pagination-top">
          <div className="-pagination">
            <div className="-previous">
              <button
                type="button"
                onClick={() => setCurrentPage(--currentPage)}
                disabled={currentPage === 1}
                className="-btn"
              >
                Previous
              </button>
            </div>
            <div className="-center">
              <GridContainer className={classes.gridContainer}>
                <GridItem xs={12} sm={6} md={4}>
                  <FormControl
                    fullWidth
                    className={
                      classes.selectFormControl +
                      " " +
                      classes.formControlMargins
                    }
                  >
                    <Select
                      MenuProps={{
                        className: classes.selectMenu,
                      }}
                      classes={{
                        select: classes.select,
                      }}
                      value={currentPage}
                      onChange={(event) => {
                        setCurrentPage(event.target.value);
                      }}
                      inputProps={{
                        name: "pageSelect",
                        id: "page-select",
                      }}
                      placeholder="Page 1"
                    >
                      {Array.from({ length: totalPages }, (_, i) => (
                        <MenuItem
                          key={i}
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value={++i}
                        >
                          Page {i}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={6} md={4}>
                  <FormControl
                    fullWidth
                    className={
                      classes.selectFormControl +
                      " " +
                      classes.formControlMargins
                    }
                  >
                    <Select
                      MenuProps={{
                        className: classes.selectMenu,
                      }}
                      classes={{
                        select: classes.select,
                      }}
                      value={pageSize}
                      onChange={(event) => {
                        setPageSize(event.target.value);
                        setCurrentPage(1);
                      }}
                      inputProps={{
                        name: "numberOfRows",
                        id: "number-of-rows",
                      }}
                    >
                      {numberOfRowsData.map((prop) => {
                        return (
                          <MenuItem
                            key={prop}
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value={prop}
                          >
                            {prop} rows
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
              </GridContainer>
            </div>
            <div className="-next">
              <button
                type="button"
                onClick={() => setCurrentPage(++currentPage)}
                disabled={currentPage === totalPages}
                className="-btn"
              >
                Next
              </button>
            </div>
          </div>
        </div>
        <table {...getTableProps()} className="rt-table">
          <thead className="rt-thead -header">
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()} className="rt-tr">
                {headerGroup.headers.map((column, key) => (
                  <th
                    {...column.getHeaderProps()}
                    className={classnames("rt-th rt-resizable-header", {
                      "-cursor-pointer": headerGroup.headers.length - 1 !== key,
                      "-sort-asc":
                        column?.id === sortColumn && sortOrder === "asc",
                      "-sort-desc":
                        column?.id === sortColumn && sortOrder === "desc",
                    })}
                    onClick={() => {
                      setSortColumn(column?.id);
                      setOrder(sortOrder === "desc" ? "asc" : "desc");
                    }}
                  >
                    <div
                      style={{ textAlign: "left" }}
                      className="rt-resizable-header-content"
                    >
                      {column.render("Header")}
                    </div>
                    {/* Render the columns filter UI */}
                    <div onClick={(e) => e.stopPropagation()}>
                      {column.id === "status"
                        ? SelectInput(column.id, [
                            {
                              value: 1,
                              label: "Complete",
                            },
                            { value: 2, label: "In Progress" },
                            { value: "1,2", label: "All" },
                          ])
                        : column.id === "createdAt"
                        ? DateInput(column.id)
                        : column.isFilter
                        ? TextSearchInput(column.id)
                        : null}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()} className="rt-tbody">
            {isLoading ? (
              <div className="loader">
                <CircularProgress />
              </div>
            ) : rows.length === 0 ? (
              <tr>
                <td> No record Found</td>
              </tr>
            ) : (
              rows.map((row, i) => {
                prepareRow(row);
                return (
                  <tr
                    onClick={() => open_link(row)}
                    {...row.getRowProps()}
                    className={classnames(
                      "rt-tr",
                      { " -odd": i % 2 === 0 },
                      { " -even": i % 2 === 1 }
                    )}
                  >
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()} className="rt-td">
                          {cell.render("Cell")}
                        </td>
                      );
                    })}
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
        <div className="pagination-bottom"></div>
      </div>
    </>
  );
}

export default ReactTable;
